import { render, staticRenderFns } from "./PreviewFooter.vue?vue&type=template&id=740ebf74&scoped=true&"
import script from "./PreviewFooter.vue?vue&type=script&lang=js&"
export * from "./PreviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFooter.vue?vue&type=style&index=0&id=740ebf74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ebf74",
  null
  
)

export default component.exports